export function isInvoiceStatusLocked(invoice) {
  const status = String((invoice && invoice.status) || '').toLowerCase();
  return status === 'approved';
}
